module.exports = __webpack_public_path__ + "static/media/back-white-wall.996073ba.svg";